import React from 'react';
import Toggle, { TogglePropTypes } from '../toggle';
import { filterType } from '../../../../../../../types';

const SubscriptionToggle = ({ filter, ...rest }) => {
    if (!filter) {return null;}

    return (
        <Toggle selectedValue={true}
            title="search_perseus.filters.global.subscription.title"
            educationContent="search_perseus.filters.global.subscription.educationContent"
            text="search_perseus.filters.global.subscription.text"
            showNotification
            tooltip
            {...filter}
            {...rest}/>
    );
};

SubscriptionToggle.propTypes = {
    filter: filterType,
    ...TogglePropTypes
};

export default SubscriptionToggle;
